export const en = {
  "brand.name": "Syria3Hours",

  "common.loading": "Loading",
  "common.loadFailed": "This page couldn't load",
  "common.actionFailed": "That didn't work. Try again.",
  "common.actions": "Actions",
  "common.cancel": "Cancel",
  "common.close": "Close",
  "common.discard": "Discard",
  "common.optional": "(optional)",

  "roles.admin": "Administrator",
  "roles.editor": "Editor",

  "shell.navLabel": "Main navigation",
  "shell.markLabel": "Syria3Hours logo, with the current 3-hour window filled on the clock",
  "shell.damascusTime": "{time} in Damascus",
  "shell.switchLanguage": "Switch language",
  "shell.darkMode": "Use dark theme",
  "shell.lightMode": "Use light theme",
  "shell.signOut": "Sign out",
  "shell.openMenu": "Open menu",

  "nav.groupNewsroom": "Newsroom",
  "nav.groupPipeline": "Pipeline",
  "nav.overview": "Today",
  "nav.review": "Review queue",
  "nav.publishLog": "Publish log",
  "nav.telegram": "Telegram sources",
  "nav.ai": "AI settings",
  "nav.schedules": "Schedules",
  "nav.platforms": "Platforms",
  "nav.notifications": "Alerts",

  "login.subtitle": "Sign in to review and publish the latest summaries.",
  "login.username": "Username",
  "login.password": "Password",
  "login.submit": "Sign in",
  "login.failed": "Sign-in failed. Check your username and password.",

  "notFound.title": "There's no page here",
  "notFound.body": "The link may be old, or the page moved.",
  "notFound.back": "Go to today's overview",

  "status.draft": "Draft",
  "status.approved": "Approved",
  "status.rejected": "Rejected",
  "status.published": "Published",
  "status.queued": "Queued",
  "status.sent": "Sent",
  "status.failed": "Failed",
  "status.manual": "Post by hand",
  "status.running": "Running",
  "status.succeeded": "Done",
  "status.empty": "No news",
  "status.skipped": "Skipped",
  "status.pending_code": "Waiting for code",
  "status.pending_password": "Waiting for password",
  "status.active": "Signed in",
  "status.revoked": "Signed out",
  "status.critical": "Critical",
  "status.warning": "Warning",
  "status.info": "Info",
  "status.flagged": "Flagged",

  "overview.writtenBy": "Summaries are written by",
  "overview.autoApproveOn": "Auto-approve is on for unflagged summaries",
  "overview.autoApproveOff": "Every summary waits for an editor",
  "overview.windows": "Today's windows",
  "overview.inProgress": "Collecting",
  "overview.upcoming": "Later today",
  "overview.noRun": "No summary",
  "overview.quietWindow": "No new messages in this window.",
  "overview.runFailed": "The summary run failed.",
  "overview.messagesFolded": "Messages: {n}, repeats folded: {d}",
  "overview.draftsWaiting": "Drafts to review",
  "overview.flaggedNote": "Flagged by the model: {n}",
  "overview.approvedWaiting": "Approved, not yet posted",
  "overview.publishFailures": "Failed posts, last 24 h",
  "overview.messagesToday": "Messages today",
  "overview.foldedNote": "Repeats folded: {n}",
  "overview.spend": "AI spend this month",
  "overview.ofBudget": "of {budget} budget",
  "overview.viewAlert": "See alert",
  "overview.emailFailingTitle": "Alert emails are failing",
  "overview.emailFailingBody":
    "Critical alerts this week that couldn't be emailed: {n}. Check the mail server settings under Alerts.",
  "overview.waiting": "Waiting for review",
  "overview.openQueue": "Open the queue",
  "overview.queueEmpty": "Nothing to review right now.",
  "overview.listener": "Telegram listener",
  "overview.noAccounts": "No Telegram account is signed in, so no messages are coming in.",
  "overview.addAccount": "Add an account",
  "overview.listening": "is listening",
  "overview.lastSeen": "last heard from {when}",
  "overview.neverConnected": "hasn't connected yet",
  "overview.channelsActive": "Channels read: {n}. Messages in the last 3 hours: {m}.",

  "review.title": "Review queue",
  "review.description":
    "Check each draft against its sources, fix the wording, then approve or publish it.",
  "review.filterLabel": "Show summaries",
  "review.filterDraft": "To review",
  "review.filterFlagged": "Flagged",
  "review.filterAll": "All",
  "review.search": "Search headlines and text",
  "review.flagged": "Flagged by the model",
  "review.sourcesCount": "Sources: {n}",
  "review.foldedCount": "Repeats folded: {n}",
  "review.digest": "Daily digest",
  "review.digestOf": "Digest for {date}",
  "review.emptyDraftsTitle": "The queue is clear",
  "review.emptyDraftsBody": "New drafts appear here after each 3-hour run.",
  "review.emptyTitle": "No summaries match",
  "review.emptyBody": "Try another filter or clear the search.",
  "review.pickOne": "Pick a summary from the list.",
  "review.backToQueue": "Back to the queue",
  "review.sourcesButton": "Sources ({n})",
  "review.flaggedTitle": "The model flagged this summary",
  "review.rejectedBecause": "Rejected",
  "review.headline": "Headline",
  "review.body": "Summary",
  "review.bullets": "Key points",
  "review.bulletsHint": "one per line",
  "review.saveChanges": "Save changes",
  "review.saved": "Changes saved. The image is being redrawn.",
  "review.approve": "Approve",
  "review.approvedToast": "Approved. It goes out with the next publishing run.",
  "review.publishNow": "Publish now",
  "review.publishingToast": "Publishing to every enabled platform.",
  "review.edit": "Edit",
  "review.reopen": "Move back to drafts",
  "review.reopenedToast": "Moved back to drafts.",
  "review.reject": "Reject",
  "review.rejectTitle": "Reject this summary?",
  "review.rejectDescription": "It won't be published. You can move it back to drafts later.",
  "review.reason": "Reason",
  "review.rejectedToast": "Rejected.",
  "review.imageVariant": "Image size",
  "review.regenerateImage": "Redraw image",
  "review.imageRegenerated": "Image redrawn.",
  "review.imageAlt": "Summary card image",
  "review.imagePending": "The image is still being drawn",
  "review.sourcesTitle": "Source messages",
  "review.sourcesDescription":
    "What the model read for this summary. Repeats from other channels are folded underneath.",
  "review.translatedFrom": "Translated from {lang}",
  "review.openInTelegram": "Open in Telegram",
  "review.mediaOnly": "Photo or video without text",
  "review.showDuplicates": "Show folded repeats ({n})",
  "review.hideDuplicates": "Hide repeats",
  "review.runDetails": "How it was written",
  "review.model": "Model",
  "review.cost": "Cost",
  "review.tokens": "Tokens in / out",
  "review.latency": "Time taken",
  "review.attempts": "Attempts",
  "review.messagesIn": "Messages read",
  "review.publishing": "Publishing",
  "review.notPublishedYet": "Not sent to any platform yet.",
  "review.viewPost": "View post",
  "review.history": "History",

  "revision.created": "Written by the model",
  "revision.edited": "Edited",
  "revision.approved": "Approved",
  "revision.auto_approved": "Approved automatically",
  "revision.rejected": "Rejected",
  "revision.reopened": "Moved back to drafts",
  "revision.publish_requested": "Publish requested",
  "revision.published": "Published everywhere",

  "dedup.": "Original",
  "dedup.forward": "Forwarded copy",
  "dedup.exact": "Same text",
  "dedup.normalized": "Same text, different links or emoji",
  "dedup.simhash": "Near-identical wording",

  "platform.telegram": "Telegram channel",
  "platform.facebook": "Facebook Page",
  "platform.instagram": "Instagram",
  "platform.x": "X",
  "platform.whatsapp": "WhatsApp Channel",
  "platform.telegram.note": "Posts the image and full text through a bot",
  "platform.facebook.note": "Photo post on your Page",
  "platform.instagram.note": "Square image with caption; needs public image links",
  "platform.x.note": "Headline, image and link; paid API access required",
  "platform.whatsapp.note": "No API exists; copy approved summaries from the export",

  "platformField.bot_token": "Bot token",
  "platformField.chat_id": "Channel",
  "platformField.page_access_token": "Page access token",
  "platformField.page_id": "Page ID",
  "platformField.access_token": "Access token",
  "platformField.ig_user_id": "Instagram business account ID",
  "platformField.api_key": "API key",
  "platformField.api_secret": "API key secret",
  "platformField.access_token_secret": "Access token secret",
  "platformField.link_url": "Link to add to each post",
  "platformField.channel_url": "Channel link",
  "platformField.footer": "Text added to every post",

  "telegram.title": "Telegram sources",
  "telegram.description":
    "Signed-in accounts read public channels. New messages arrive within seconds and repeats are folded automatically.",
  "telegram.accounts": "Accounts",
  "telegram.accountsDescription":
    "Use a dedicated number. Keep about 20 channels per account to stay clear of Telegram's limits.",
  "telegram.addAccount": "Add account",
  "telegram.noAccountsTitle": "No accounts yet",
  "telegram.noAccountsBody":
    "Add a phone number. Telegram sends it a login code, and you enter that code here.",
  "telegram.listening": "Listening",
  "telegram.notListening": "Not listening",
  "telegram.lastSeen": "Last heard {when}",
  "telegram.channelCount": "Channels: {n}",
  "telegram.finishSignIn": "Finish signing in",
  "telegram.removeAccount": "Remove account",
  "telegram.removeTitle": "Remove this account?",
  "telegram.removeDescription":
    "The listener stops using it. Its channels stay, and another signed-in account takes them over.",
  "telegram.removed": "Account removed.",
  "telegram.signInTitle": "Sign in a Telegram account",
  "telegram.signInDescription": "This works like signing in to Telegram on a new device.",
  "telegram.steps": "Sign-in steps",
  "telegram.step.phone": "Phone number",
  "telegram.step.code": "Login code",
  "telegram.step.password": "Two-step password",
  "telegram.phone": "Phone number",
  "telegram.phoneHint": "International format, starting with +",
  "telegram.label": "Name",
  "telegram.labelHint": "To tell accounts apart, e.g. Reader 1",
  "telegram.sendCode": "Send login code",
  "telegram.code": "Login code",
  "telegram.notConfiguredTitle": "Telegram isn't connected to this server yet",
  "telegram.notConfiguredBody":
    "No login code can be sent until the server has Telegram API credentials. Create them at my.telegram.org → API development tools, put TELEGRAM_API_ID and TELEGRAM_API_HASH in the server's .env, then restart the api and listener services.",
  "telegram.notSentYet": "No login code has been sent to {phone} yet.",
  "telegram.codeVia.app":
    'Telegram sent the code inside the Telegram app, not by SMS. Open Telegram on a phone or computer where {phone} is already signed in and look for a message from "Telegram".',
  "telegram.codeVia.sms": "Telegram sent the code by SMS to {phone}.",
  "telegram.codeVia.call": "Telegram is calling {phone} to read out the code.",
  "telegram.codeVia.flash_call":
    "Telegram will ring {phone} briefly. The code is the last digits of the calling number.",
  "telegram.codeVia.missed_call":
    "Telegram will ring {phone} once. The code is the last digits of the calling number.",
  "telegram.codeVia.email": "Telegram sent the code to the login email set on this account.",
  "telegram.codeVia.fragment":
    "Telegram sent the code through Fragment, for this anonymous number.",
  "telegram.codeVia.unknown": "Telegram sent a login code for {phone}.",
  "telegram.resendVia.sms": "Send it by SMS instead",
  "telegram.resendVia.call": "Call me with the code",
  "telegram.resendVia.flash_call": "Get the code by phone call",
  "telegram.resendVia.missed_call": "Get the code by phone call",
  "telegram.resendVia.fragment": "Send it through Fragment",
  "telegram.codeResent": "A new code is on its way.",
  "telegram.resendCode": "Send a new code",
  "telegram.verify": "Sign in",
  "telegram.password": "Two-step verification password",
  "telegram.passwordHint": "This account has a cloud password. Enter it to finish.",
  "telegram.signedIn": "{name} is signed in. The listener starts within a minute.",
  "telegram.channels": "Channels",
  "telegram.channelsDescription":
    "Public channels to read. Subscribing joins the channel and fetches its recent posts.",
  "telegram.needAccount": "Sign in an account first. Channels are read through it.",
  "telegram.channelUsername": "Channel username or link",
  "telegram.lookUp": "Look up",
  "telegram.subscribers": "Subscribers: {n}",
  "telegram.alreadySubscribed": "Already in your sources",
  "telegram.readWith": "Read with",
  "telegram.anyAccount": "Any account",
  "telegram.subscribe": "Add channel",
  "telegram.subscribed": "Added {title}. Recent posts are being fetched.",
  "telegram.noChannelsTitle": "No channels yet",
  "telegram.noChannelsBody":
    "Look up a public channel by its @username or t.me link to start collecting news.",
  "telegram.channel": "Channel",
  "telegram.messagesToday": "Today",
  "telegram.lastPost": "Last post",
  "telegram.reading": "Reading",
  "telegram.backfill": "Fetch missed posts",
  "telegram.unsubscribe": "Remove channel",
  "telegram.unsubscribed": "Removed {title}.",

  "ai.title": "AI settings",
  "ai.description":
    "Every change saves a new version, so you can see what changed and when. Output is always in Modern Standard Arabic.",
  "ai.onThisPage": "On this page",
  "ai.nav.connection": "OpenRouter key",
  "ai.nav.model": "Model",
  "ai.nav.generation": "Generation",
  "ai.nav.routing": "Providers",
  "ai.nav.prompt": "Instructions",
  "ai.nav.guidelines": "Editorial guidelines",
  "ai.nav.automation": "Approval and budget",
  "ai.nav.usage": "Spending",
  "ai.nav.test": "Test run",
  "ai.connection": "OpenRouter key",
  "ai.connectionDescription":
    "One OpenRouter key gives access to every model. It's stored encrypted and never shown again.",
  "ai.keyStored": "Key saved",
  "ai.noKey": "No key saved. Summaries can't run until you add one.",
  "ai.apiKey": "API key",
  "ai.replaceKey": "Replace key",
  "ai.keyHint": "Create one at openrouter.ai/keys.",
  "ai.saveKey": "Save key",
  "ai.checkKey": "Check key and credits",
  "ai.removeKey": "Remove key",
  "ai.keySaved": "Key saved.",
  "ai.keyRemoved": "Key removed. Summaries stop until a new key is saved.",
  "ai.keyValid": "OpenRouter accepted the key",
  "ai.keyInvalid": "OpenRouter rejected the key",
  "ai.balance": "Credits left",
  "ai.keyLimit": "Key spending limit",
  "ai.keyUsage": "Spent with this key",
  "ai.modelTitle": "Model",
  "ai.modelDescription":
    "The primary model writes every summary. If it's down or rate-limited, OpenRouter moves to the fallbacks in order.",
  "ai.missingModels": "These models are no longer on OpenRouter. Pick replacements.",
  "ai.primaryModel": "Primary model",
  "ai.fallbacks": "Fallback models",
  "ai.noFallbacks": "No fallbacks. A provider outage stops the run.",
  "ai.fallbacksHint":
    "Pick fallbacks from different companies so one outage doesn't take them all down.",
  "ai.moveUp": "Move up",
  "ai.moveDown": "Move down",
  "ai.removeFallback": "Remove fallback",
  "ai.searchModels": "Search models",
  "ai.minContext": "Context at least",
  "ai.any": "Any",
  "ai.refreshList": "Refresh list",
  "ai.catalogRefreshed": "Model list updated. Models: {n}.",
  "ai.model": "Model",
  "ai.context": "Context",
  "ai.priceIn": "Input, per 1M",
  "ai.priceOut": "Output, per 1M",
  "ai.primary": "Primary",
  "ai.use": "Use",
  "ai.isFallback": "Fallback",
  "ai.addFallbackFor": "Add {model} as a fallback",
  "ai.noModels": "No models match.",
  "ai.catalogMeta": "Models: {n}. List updated {when}.",
  "ai.generation": "Generation",
  "ai.generationDescription": "Lower temperature keeps summaries close to the sources.",
  "ai.temperature": "Temperature",
  "ai.temperatureHint": "0.2–0.4 suits news. Higher values add variety and risk.",
  "ai.maxTokens": "Longest reply",
  "ai.maxTokensHint": "In tokens. A summary usually needs 600–1,200.",
  "ai.topP": "Top P",
  "ai.routing": "Providers",
  "ai.routingDescription": "Control which companies OpenRouter may send your source messages to.",
  "ai.noTraining": "Only providers that don't train on prompts",
  "ai.noTrainingHint": "Source messages can contain people's names. Keep this on.",
  "ai.providerFallbacks": "Let OpenRouter try other providers of the same model",
  "ai.providerFallbacksHint": "Keeps runs going when one host of a model is down.",
  "ai.sortBy": "Prefer providers by",
  "ai.sortDefault": "OpenRouter's default balance",
  "ai.sortPrice": "Lowest price",
  "ai.sortThroughput": "Fastest output",
  "ai.sortLatency": "Quickest first token",
  "ai.providerOrder": "Preferred providers",
  "ai.providerOrderHint": "Comma-separated provider names, tried first and in this order.",
  "ai.systemPrompt": "Instructions",
  "ai.systemPromptDescription": "Tells the model what kind of editor to be. Write it in Arabic.",
  "ai.fixedRules":
    "The Arabic-only rule and the reply format are added automatically and can't be changed here.",
  "ai.guidelines": "Editorial guidelines",
  "ai.guidelinesDescription":
    "Rules for sensitive cases, one per line. The model flags any summary where a rule applies, and flagged summaries always wait for an editor.",
  "ai.flaggedThisWeek": "flagged this week",
  "ai.guidelineHistory": "Earlier versions ({n})",
  "ai.current": "Current",
  "ai.noGuidelines": "No guidelines.",
  "ai.automation": "Approval and budget",
  "ai.automationDescription":
    "Decide what can go out without an editor, and how much the AI may spend.",
  "ai.autoApprove": "Publish unflagged summaries without review",
  "ai.autoApproveHint":
    "Flagged summaries still wait for an editor. Keep this off until you trust the guidelines.",
  "ai.windowHours": "Hours per summary",
  "ai.windowHoursHint": "Used when there's no earlier run to continue from.",
  "ai.maxMessages": "Most messages per summary",
  "ai.maxMessagesHint": "The newest ones are kept when there are more.",
  "ai.monthlyBudget": "Monthly budget (USD)",
  "ai.monthlyBudgetHint": "Runs stop when spending reaches this. 0 means no limit.",
  "ai.budgetAlert": "Warn at (% of budget)",
  "ai.budgetAlertHint": "Sends an alert once a month when spending passes this share.",
  "ai.lowCredit": "Warn when credits drop below (USD)",
  "ai.lowCreditHint": "Checked every hour.",
  "ai.usage": "Spending",
  "ai.usageDescription": "Cost of every run in the last 30 days, test runs included.",
  "ai.spentThisMonth": "Spent this month",
  "ai.budgetUsed": "Share of monthly budget used",
  "ai.ofBudget": "{pct}% of {budget}",
  "ai.noSpendYet": "No runs in the last 30 days.",
  "ai.legend": "Models",
  "ai.otherModels": "Other models",
  "ai.chartLabel": "Daily AI spend over the last {days} days, stacked by model",
  "ai.total": "Total",
  "ai.byModel": "Spend by model",
  "ai.runs": "Runs",
  "ai.tokensInOut": "Tokens in / out",
  "ai.cost": "Cost",
  "ai.test": "Test run",
  "ai.testDescription":
    "Summarizes the last 3 hours with the saved settings. Nothing is published, but the run costs credits.",
  "ai.testButton": "Test on the last 3 hours",
  "ai.testUsesSaved": "Save your changes first; the test uses saved settings.",
  "ai.testEmpty": "No messages came in during the last 3 hours.",
  "ai.wouldBeFlagged": "Would be flagged",
  "ai.tokensShort": "{a} in, {b} out",
  "ai.messagesUsed": "Messages: {n}",
  "ai.unsaved": "Unsaved changes: {n}",
  "ai.saveVersion": "Save as new version",
  "ai.saved": "Saved. New runs use these settings.",

  "schedules.title": "Schedules",
  "schedules.description": "When each job runs. Changes apply within a minute, no restart needed.",
  "schedules.add": "Add schedule",
  "schedules.emptyTitle": "No schedules",
  "schedules.emptyBody":
    "Without schedules nothing runs on its own. Add one to summarize every 3 hours.",
  "schedules.name": "Name",
  "schedules.job": "Job",
  "schedules.when": "When",
  "schedules.atTimes": "At set times",
  "schedules.everyN": "Every few minutes",
  "schedules.cron": "Cron expression",
  "schedules.cronHint": "minute hour day month weekday, e.g. 0 */3 * * *",
  "schedules.minutes": "Minutes between runs",
  "schedules.hours": "Hours to cover",
  "schedules.hoursHint": "Leave empty to continue from the previous run.",
  "schedules.enabled": "On",
  "schedules.lastRun": "Last run",
  "schedules.runs": "Runs",
  "schedules.never": "Never",
  "schedules.runNow": "Run now",
  "schedules.edit": "Edit schedule",
  "schedules.delete": "Delete schedule",
  "schedules.deleted": "Schedule deleted.",
  "schedules.started": "{name} started.",
  "schedules.editTitle": "Edit schedule",
  "schedules.newTitle": "New schedule",
  "schedules.save": "Save schedule",
  "schedules.saved": "Schedule saved.",
  "schedules.timezoneNote": "Times are in Damascus time.",
  "schedule.kind.summarize": "Summarize the latest window",
  "schedule.kind.digest": "Write the daily digest",
  "schedule.kind.publish": "Post approved summaries",
  "schedule.kind.catalog_sync": "Refresh models and check credits",
  "schedule.kind.backfill": "Fetch missed Telegram posts",
  "schedule.kind.listener_health": "Check the Telegram listener",
  "schedule.kind.alert_digest": "Email the alert digest",

  "cron.everyNHours": "Every {n} hours, on the hour",
  "cron.everyNHoursAt": "Every {n} hours at :{m}",
  "cron.hourlyAt": "Every hour at :{m}",
  "cron.dailyAt": "Every day at {time}",
  "cron.dailyAtList": "Every day at {times}",
  "cron.everyNMinutes": "Every {n} minutes",

  "platforms.title": "Platforms",
  "platforms.description":
    "Where approved summaries are posted. Credentials are stored encrypted and only the last characters are shown.",
  "platforms.manual": "Manual",
  "platforms.configured": "Ready",
  "platforms.notConfigured": "Needs settings",
  "platforms.testPassed": "Connection works",
  "platforms.testFailed": "Connection failed",
  "platforms.noPosts": "No posts yet",
  "platforms.enabled": "Post here",
  "platforms.enabledToast": "Posting to {name} is on.",
  "platforms.disabledToast": "Posting to {name} is off.",
  "platforms.storedSecret": "Saved: {masked}. Leave empty to keep it.",
  "platforms.keepCurrent": "Leave empty to keep the saved value",
  "platforms.save": "Save settings",
  "platforms.saved": "{name} settings saved.",
  "platforms.test": "Test connection",
  "platforms.lastTest": "Last connection test",
  "platforms.lastError": "Last error",
  "platforms.instagramNote":
    "Instagram downloads the image from its link, so images must be stored on public HTTPS storage (S3, R2 or MinIO behind a domain).",
  "platforms.xNote": "Posting needs a paid X API plan. It stays off until you switch it on.",
  "platforms.whatsappNote": "WhatsApp Channels can't be posted to automatically.",
  "platforms.openExport": "Open the copy-and-paste export",

  "log.title": "Publish log",
  "log.description":
    "Every post attempt, per platform. Failed posts are retried automatically up to 5 times.",
  "log.tabJobs": "All posts",
  "log.tabWhatsapp": "WhatsApp export",
  "log.view": "View",
  "log.statusFilter": "Filter by status",
  "log.all": "All",
  "log.platform": "Platform",
  "log.allPlatforms": "All platforms",
  "log.summary": "Summary",
  "log.status": "Status",
  "log.attempts": "Attempts",
  "log.updated": "Updated",
  "log.retry": "Retry",
  "log.retrying": "Trying again.",
  "log.emptyTitle": "Nothing posted yet",
  "log.emptyBody": "Posts appear here after you approve a summary and a platform is switched on.",
  "log.whatsappIntro":
    "Copy each approved summary into your WhatsApp Channel with its square image, then mark it as posted.",
  "log.period": "Period",
  "log.today": "Last 24 hours",
  "log.threeDays": "3 days",
  "log.week": "7 days",
  "log.copyAll": "Copy all",
  "log.copyText": "Copy text",
  "log.copied": "Copied",
  "log.downloadImage": "Image",
  "log.markPosted": "Mark as posted",
  "log.markedPosted": "Marked as posted.",
  "log.whatsappEmptyTitle": "Nothing to post",
  "log.whatsappEmptyBody": "Approved summaries from this period appear here.",

  "pager.status": "Page {page} of {pages}",
  "pager.previous": "Previous",
  "pager.next": "Next",

  "notifications.title": "Alerts",
  "notifications.description":
    "Email the owner when summaries stop: OpenRouter problems, budget limits, a disconnected listener or failed posts.",
  "notifications.notConfiguredTitle": "Alert emails aren't set up",
  "notifications.notConfiguredBody":
    "Alerts are recorded below but no one is emailed. Fill in the mail server and recipients.",
  "notifications.email": "Mail server",
  "notifications.emailDescription":
    "Any SMTP service works: your mail provider, Amazon SES, Mailgun or Postmark.",
  "notifications.enabled": "Send alert emails",
  "notifications.enabledHint": "When off, alerts still appear in the history below.",
  "notifications.host": "SMTP server",
  "notifications.port": "Port",
  "notifications.security": "Encryption",
  "notifications.starttls": "STARTTLS (587)",
  "notifications.ssl": "SSL (465)",
  "notifications.noEncryption": "None",
  "notifications.username": "Username",
  "notifications.password": "Password",
  "notifications.passwordStored": "Saved: {masked}. Leave empty to keep it.",
  "notifications.from": "From address",
  "notifications.recipients": "Send alerts to",
  "notifications.recipientsHint": "One address per line.",
  "notifications.testTo": "Send the test to",
  "notifications.sendTest": "Send test email",
  "notifications.testSent": "Test email sent",
  "notifications.testFailed": "The mail server refused the test email",
  "notifications.testNote": "The test uses the saved settings. Save first if you changed anything.",
  "notifications.events": "What to email about",
  "notifications.eventsDescription":
    "Repeats of the same problem are held back during the cooldown so your inbox doesn't fill up.",
  "notifications.cooldown": "Cooldown (minutes)",
  "notifications.cooldownHint": "Minimum gap between emails about the same problem.",
  "notifications.digest": "Group warnings into one daily email",
  "notifications.digestHint":
    "Critical alerts are still sent straight away. Set the time on the Schedules page.",
  "notifications.save": "Save alert settings",
  "notifications.saved": "Alert settings saved.",
  "notifications.history": "Alert history",
  "notifications.historyDescription":
    "Every alert raised, emailed or not. Open one to see the full email.",
  "notifications.markAllSeen": "Mark all as seen",
  "notifications.severity": "Severity",
  "notifications.noAlertsTitle": "No alerts",
  "notifications.noAlertsBody": "Problems with summaries, the listener or publishing show up here.",
  "notifications.emailed": "Emailed",
  "notifications.emailFailed": "Email failed",
  "notifications.suppressedCooldown": "Held back, cooldown",
  "notifications.suppressedDisabled": "Not emailed, switched off",
  "notifications.suppressedEmailOff": "Not emailed, email off",
  "notifications.heldForDigest": "Waiting for digest",
  "notifications.inDigest": "Sent in digest",
  "notifications.sending": "Sending",

  "event.openrouter_outage": "OpenRouter can't be reached",
  "event.openrouter_outage.hint": "Server errors or timeouts after every retry and fallback.",
  "event.openrouter_auth": "OpenRouter rejects the key",
  "event.openrouter_auth.hint": "The key was revoked, mistyped or is missing.",
  "event.openrouter_credits": "Credits are low or used up",
  "event.openrouter_credits.hint":
    "Balance below your threshold, or OpenRouter refused a run for payment.",
  "event.budget_exceeded": "Monthly budget reached",
  "event.budget_exceeded.hint": "Runs are skipped until next month or until you raise the budget.",
  "event.model_unavailable": "A chosen model was removed",
  "event.model_unavailable.hint": "The primary or a fallback model disappeared from OpenRouter.",
  "event.invalid_output": "The model's reply was unusable",
  "event.invalid_output.hint": "Wrong format twice in a row, so the run failed.",
  "event.listener_disconnected": "Telegram listener stopped",
  "event.listener_disconnected.hint":
    "No heartbeat from the listener, or an account was signed out.",
  "event.publish_failed": "A post failed",
  "event.publish_failed.hint": "A platform refused the post after every retry.",
} as const;

export type MessageKey = keyof typeof en;
